module.exports = __webpack_public_path__ + "img/specials-multislider-hyundai.00de79a8.png";